import React from "react";
import CustomButton from "Components/Custom/CustomButton";
import Icon from "Components/Icons/Icon";

interface PublicPageCardProps {
  /** Optional icon/image node shown centred at top */
  icon?: React.ReactNode;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonLoading?: boolean;
  /** Show "Secure payment powered by Stripe" badge above button */
  isPoweredBy?: boolean;
  /** Show "Skip for Now" link below button */
  isSkip?: boolean;
  skipText?: string;
  onSkip?: () => void;
  amount?: number;
}

const PublicPageCard: React.FC<PublicPageCardProps> = ({
  icon,
  title,
  description,
  buttonText,
  onButtonClick,
  buttonLoading,
  isPoweredBy,
  isSkip,
  skipText,
  onSkip,
  amount = 0,
}) => {
  return (
    <div>
      {/* Icon */}
      {icon && <div className="text-center mb-3">{icon}</div>}

      {/* Title */}
      <h5 className="font-primary fs-24 text-black2D fw-semibold mb-3 text-center mt-1">
        {title}
      </h5>

      {/* Description */}
      <p className="font-primary fs-14 text-grey89 fw-normal mb-4 text-center">
        {description}
      </p>

      {amount > 0 && (
        <div className="text-center mb-3">
          <h3 className="font-primary fw-semibold text-green mb-0 fs-24">
            £
            {amount.toLocaleString("en-GB", {
              minimumFractionDigits: 0,
            })}
          </h3>
        </div>
      )}

      {/* Secure payment badge */}
      {isPoweredBy && (
        <div className="d-flex align-items-center justify-content-center gap-1 mb-4">
          <Icon name="Secure" className="me-1" />
          <span className="font-primary fs-14 text-grey89 fw-normal">
            Secure payment powered by Stripe
          </span>
        </div>
      )}

      {/* Primary button */}
      {buttonText && (
        <CustomButton
          text={buttonText}
          onClick={onButtonClick}
          loading={buttonLoading}
          className="auth-Button"
          textClassName="fs-16"
        />
      )}

      {/* Skip for Now */}
      {isSkip && (
        <div className="mt-2">
          <CustomButton
            text={skipText || "Skip for Now"}
            onClick={onSkip}
            newClassName="d-flex w-100 justify-content-center btn-light"
            textClassName="fs-16"
            textColor="text-black2D"
            disabled={buttonLoading}
          />
        </div>
      )}
    </div>
  );
};

export default PublicPageCard;
